import React, { useContext } from 'react';
import { LogoWithText } from '@sm/webassets';
import { t } from '@sm/intl';
import { Container, Typography } from '@sm/wds-react';
import { sanitizeString } from '@sm/utils';
import HeroFormCTA from '~app/components/HeroFormCTA';
import COPY from '~app/pages/EnterpriseThankYou/copy';
import { PageVariants, EnterpriseThankYouContext } from '~app/pages/EnterpriseThankYou';
import './enterprise-thank-you-footer.scss';

const EnterpriseThankYouFooter = () => {
  const { pageVariant } = useContext(EnterpriseThankYouContext);

  const flagPremiumCustom = () => {
    return pageVariant === PageVariants.premiumCustom ? 'sm-enterprise-thank-you-footer__premium-flag' : '';
  };

  const heroFormCTAArgs = {
    className: 'sm-hero-form-cta__enterprise-thank-you',
    ctaFormEmail: t(COPY.SIGN_UP_FORM_CTA_EMAIL_ADDRESS),
    ctaFormEmailPlaceholder: t(COPY.SIGN_UP_FORM_CTA_EMAIL_ADDRESS),
    ctaFormNewsletterOptOut: '',
    ctaFormPassword: t(COPY.SIGN_UP_FORM_CTA_PASSWORD),
    ctaFormPasswordPlaceholder: t(COPY.SIGN_UP_FORM_CTA_PASSWORD),
    ctaFormPrivacyConsent: 'privacy consent',
    ctaFormSubmit: t(COPY.SIGN_UP_FORM_CTA_SUBMIT),
    disclaimer: t(COPY.SIGN_UP_DISCLAIMER),
    utSource: 'enterprise_thank_you',
    utSource2: 'rebrand_ep_form',
    showThirdPartySignUpActions: false,
    showDisclaimer: false,
  };

  const Disclamer = () => {
    return (
      <If condition={pageVariant === PageVariants.standard}>
        <Container className="sm-enterprise-thank-you-footer__disclaimer">
          <Typography
            align="center"
            component="div"
            variant="bodySm"
            color="dark-muted"
            className="sm-enterprise-thank-you-footer__disclaimer-typography"
            data-testid="footer__Disclamer"
            dangerouslySetInnerHTML={{ __html: sanitizeString(t(COPY.SIGN_UP_DISCLAIMER)) }}
          />
        </Container>
      </If>
    );
  };

  const Footer = () => {
    return (
      <Container
        data-testid="footer__Footer"
        className={`${flagPremiumCustom()} sm-enterprise-thank-you-footer__outline`}
      >
        <Container className="sm-enterprise-thank-you-footer__powered-by-container" flex flexJustify="center">
          <Typography
            component="div"
            align="center"
            color="light"
            className="sm-enterprise-thank-you-footer__powered-by-text"
          >
            {t(COPY.POWERED_BY_TEXT)}
          </Typography>
        </Container>
        <Container flex flexJustify="center" className="sm-enterprise-thank-you-footer__branding-logo-container">
          <LogoWithText className="sm-enterprise-thank-you-footer__branding-logo" color="alt" />
        </Container>
        <Container className="sm-enterprise-thank-you-footer__branding-text" flex flexJustify="center">
          <Typography className="sm-enterprise-thank-you-footer__branding-text-inner">
            {t(COPY.SIGN_UP_CALLOUT_SUB_HEADER)}
          </Typography>
        </Container>
        <If condition={pageVariant === PageVariants.standard}>
          <Container className="sm-enterprise-thank-you-footer__sign-up-container" flex flexJustify="center">
            <HeroFormCTA className="sm-enterprise-thank-you__sign-up" {...heroFormCTAArgs} />
          </Container>
        </If>
      </Container>
    );
  };

  return (
    <>
      <Footer />
      <Disclamer />
    </>
  );
};

export default EnterpriseThankYouFooter;
